export default __webpack_public_path__ + "static/media/cam-back.2f7af6e8.svg";